export const TERM = {
  SRC: "B2B_B2C_SCR",
  PrivacyPolicy: "B2B_PRIVACY",
  TermsOfCondition: "B2B_TERMS",
};
